import { Box, Grid, IconButton, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';

export default function GlobalDeleteModal({
  text,
  subText,
  buttonTitle,
  startIcon,
  navigateLink,
  handleClose,
  onClose, 
  onConfirm,
  currentLink,
}) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    handleClose();
    navigate(navigateLink);
  };
  
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 500,
        background: "white",
        borderRadius: "20px",
        padding: "40px 30px",
        textAlign: "center",
        boxShadow: "0px 20px 40px rgba(0,0,0,0.25)",
        position: "relative",
      }}
    >
      {/* Close Button (Top Right)z */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          backgroundColor: "#E0E0E0",
          width: 32,
          height: 32,
        }}
      >
        ✕
      </IconButton>

      {/* Delete Icon Circle */}
      <Box
        sx={{
          width: 90,
          height: 90,
          margin: "0 auto 20px",
          borderRadius: "50%",
          backgroundColor: "#FFEAE5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <DeleteIcon
          sx={{
            fontSize: 45,
            color: "#FF4D2D",
          }}
        />
      </Box>

      {/* Title */}
      <Typography
        sx={{
          fontSize: "26px",
          fontWeight: 600,
          color: "#2E2E2E",
          marginBottom: "10px",
        }}
      >
        {text}
      </Typography>

      {/* Subtitle */}
      {subText && (
        <Typography
          sx={{
            fontSize: "15px",
            color: "#6B6B6B",
            marginBottom: "30px",
          }}
        >
          {subText}
        </Typography>
      )}

      {/* Buttons */}
      <Grid container justifyContent="center" spacing={2}>
        {/* Cancel Button */}
        <Grid item>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              borderRadius: "12px",
              padding: "8px 50px",
              fontWeight: 500,
              textTransform: "none",
              borderColor: "#B39DDB",
              color: "#572575",
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "#EDE7FF",
                borderColor: "#572575",
              },
            }}
          >
            Cancel
          </Button>
        </Grid>

        {/* Delete Button (Your Existing Logic) */}
        <Grid item>
          <Button
            variant="contained"
            startIcon={startIcon}
            onClick={onConfirm}
            sx={{
              borderRadius: "12px",
              padding: "8px 50px",
              fontWeight: 500,
              textTransform: "none",
              backgroundColor: "#572575",
              // boxShadow: "0px 6px 12px #572575",
              "&:hover": {
                backgroundColor: "#572575",
              },
            }}
          >
            {buttonTitle}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
